import * as React from "react";
import { Study } from "webportalclient";
import { GuestFooter } from "./Guest/GuestFooter";
import Alert, { AlertCategoryEnum } from "./misc/components/Alert";
import LoadingWithMessage from "./misc/components/LoadingWithMessage";
import { commonHeaders } from "./misc/api/ClientResources";
import { DefaultVitalographLogo } from "./Core/VitalographLogo";
import { useAuth } from "react-oidc-context";
import { useWebPortalApiClient } from "./misc/api/WebPortalTokenClient";
import Modal from "./misc/components/modal";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";

declare const rootUrl: string;

interface SelectStudyProps {
    setStudyChange: React.Dispatch<React.SetStateAction<string>>;
}

export const SelectStudy = ({ setStudyChange }: SelectStudyProps) => {
    const { user } = useAuth();
    const [errorAlert, setErrorAlert] = React.useState();
    const client = useWebPortalApiClient();
    const [studies, setStudies] = React.useState<Study[] | undefined>();
    const [studyLogo, setStudyLogo] = React.useState<Study>({ logo: DefaultVitalographLogo });
    const [selectedStudy, setSelectedStudy] = React.useState("All Studies");
    const history = useHistory();
    const [cookies, setCookie, removeCookie] = useCookies(['WpCurrentStudy']);

    React.useEffect(() => {
        const getStudies = async () => {
            const studiesResult = await client.client.getStudies("id,name", undefined, "name");
            setStudies(studiesResult.value);
        }

        getStudies();

        return () => {
            client.abortController.abort();
        }
    }, []);

    if (!studies)
        return <LoadingWithMessage message="Loading Studies..." />

    const onOpenStudy = () => {
        setStudyChange(selectedStudy);
        const prevPath = window.sessionStorage.getItem("WebPortal.PreviousPath");
        window.sessionStorage.removeItem("WebPortal.PreviousPath")

        if (selectedStudy === "All Studies") {
            removeCookie("WpCurrentStudy", { path: "/" });
        } else {
            setCookie("WpCurrentStudy", selectedStudy, { path: "/" });
        }
        if (prevPath === "/account/signedout") {
            history.replace('/');
            return;
        }

        history.replace('/');
    }

    const onStudyChange = async (e: any) => {
        setSelectedStudy(e.target.value);
        if (e.target.value === "All Studies") {
            setStudyLogo({ logo: DefaultVitalographLogo });
        } else {
            const studyLogo = await client.client.getStudy(e.target.value, "logo,logoMediaType");
            setStudyLogo({ logo: studyLogo?.logo ? studyLogo.logo : DefaultVitalographLogo });
        }
    }

    return (
        <Modal show={true} header="Select a Study" automationId="SelectStudyModal">
            <div className="modal-body middle-box text-center">
                <div>
                    <h1 className="logo-name">
                        <img id="StudyLogo" style={{ width: 100 + '%', marginBottom: 20 + 'px' }} src={`data:${studyLogo.logoMediaType};base64,${studyLogo.logo}`} alt="Study Logo" />
                    </h1>
                    <p>
                        Please select a study.
                    </p>
                    <Alert show={errorAlert !== undefined} category={AlertCategoryEnum.Danger}>{errorAlert}</Alert>

                    <div className="form-group text-left">
                        <select id="CurrentStudyId" className="form-control" onChange={onStudyChange}>
                            <option key="All Studies" id="All" value="All Studies">All Studies</option>
                            {studies.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                        </select>
                    </div>
                    <button type="submit" className="btn btn-primary block full-width m-b" data-automationid="SelectStudySubmitButton" onClick={onOpenStudy}>Open</button>
                    <GuestFooter />
                </div>
            </div>
        </Modal>
    );
}
